import { LoadingService } from '../../../shared/services/loading/loading.service.ts';

export const printFormsTabLoadingService = new LoadingService();
